import { attr, belongsTo, hasMany } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { or, reads } from '@ember/object/computed';
import Super from './client';
import moment from 'moment-timezone';

const Validations = buildValidations({
  email: null,
  phoneNumber: null,
  firstName: validator('presence', {
    presence: true,
    messageKey: 'errors.firstNameRequired',
  }),
  lastName: validator('presence', {
    presence: true,
    messageKey: 'errors.lastNameRequired',
  }),
  birthDate: [
    validator('presence', {
      presence: true,
      disabled: reads('model.skipPrescreenerV2Validation'),
      messageKey: 'errors.birthDateRequired',
    }),
    validator('inline', {
      validate(value) {
        if (!value || value.isBefore(moment())) return true;

        return 'errors.prospectiveClient.invalidBirthDate';
      },
    }),
  ],
  state: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.prospectiveClient.state',
      messageKey: 'errors.presence',
      disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerV2Validation'),
    }),
  ],
  recaptchaResponse: [
    validator('presence', {
      presence: true,
      ignoreBlank: true,
      descriptionKey: 'errors.prospectiveClient.recaptchaResponse',
      messageKey: 'errors.prospectiveClient.recaptchaRequired',
    }),
  ],
});

export default class ProspectiveClient extends Super.extend(Validations) {
  skipContactFormSpecificValidations = false;

  @hasMany('insurance-claim', { async: false, inverse: 'client' }) insuranceClaims;
  @hasMany('insurance-info', { async: false, inverse: 'client' }) insuranceInfos;
  @hasMany('email', { async: false, inverse: null }) emails;
  @hasMany('phone', { async: false, inverse: null }) phones;

  @belongsTo('clinician', { async: false, inverse: null }) clinician;
  @attr('string', { defaultValue: 'prospective' }) status;
  @attr('string') clientMessage;
  @attr('string') genderInfo;
  @attr('string') state;
  @attr('string', { defaultValue: 'Client' }) thisType;
  @attr('string') recaptchaResponse;
  @attr('string') globalMonarchChannelName;
  @attr('string') clinicianReferral;
  @attr() clientRelationshipsAttributes;
}
